import { Step, StepStatus } from '@sdir/sds';
import { IntlShape } from 'react-intl';
import { matchPath } from 'react-router-dom';
import { routes } from '../components/Routes/constants';

export type StepDefinition = {
  label: string;
  route: string;
};

export type MspStep = Step & {
  route: string;
};

const allApplicationSteps = (hasReportees?: boolean): StepDefinition[] => {
  const items: StepDefinition[] = [];
  if (hasReportees) {
    items.push({
      label: 'application.steps.applicant',
      route: routes.applicant,
    });
  }
  return items.concat([
    {
      label: 'application.steps.sailor',
      route: routes.sailor,
    },
    {
      label: 'application.steps.certificate',
      route: routes.certificate,
    },
    {
      label: 'application.steps.requirements',
      route: routes.requirements,
    },
    /* {
      label: 'application.steps.cra',
      route: routes.cra,
    }, */
    {
      label: 'application.steps.summary',
      route: routes.summary,
    },
    {
      label: 'application.steps.payment',
      route: routes.payment,
    },
  ]);
};

export const getPrevStep = (pathname: string, hasReportees: boolean): StepDefinition | null => {
  const steps = allApplicationSteps(hasReportees);
  const indexOfMatch = steps.findIndex((s) => matchPath(s.route, pathname));
  if (indexOfMatch < 0) return null;
  return steps[indexOfMatch - 1] || null;
};

export const getNextStep = (pathname: string): StepDefinition | null => {
  const steps = allApplicationSteps();
  const indexOfMatch = steps.findIndex((s) => matchPath(s.route, pathname));
  if (indexOfMatch < 0) return null;
  return steps[indexOfMatch + 1] || null;
};

export const getCurrentSteps = (
  pathname: string,
  intl: IntlShape,
  hasReportees?: boolean
): MspStep[] => {
  const steps = allApplicationSteps(hasReportees);
  let activeFound = false;
  return steps.map((s, i) => {
    let status: StepStatus;
    if (activeFound) {
      status = StepStatus.DISABLED;
    } else if (matchPath(s.route, pathname) || pathname.includes('new')) {
      status = StepStatus.ACTIVE;
      activeFound = true;
    } else {
      status = StepStatus.DONE;
    }
    return { route: s.route, label: intl.formatMessage({ id: s.label }), value: i + 1, status };
  });
};
